
        import { Mapper } from "../../../../base/utils/mapper";
        import { ProfessionalModel } from "../../../../domain/models/configuration/professional.model";
        import { ProfessionalEntity } from "../entities/professional.entity";
        export class ProfessionalImplementationRepositoryMapper extends Mapper<ProfessionalEntity, ProfessionalModel>{
            mapFrom(param:  ProfessionalEntity):  ProfessionalModel { 
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors
                }; 
            }
            mapTo(param:  ProfessionalModel):  ProfessionalEntity {
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors 
                };
            }
        }